<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AVodUc/tc-custom/9781250297082.jpg?1730582906945" alt="This image is the cover for the book Meriwether, The American Story"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Meriwether, The American Story
      </h1>
      <p class="bookDescription body article font2">
        <p>Meriwether is a young man of genius, power , drive, and single-minded determination to make one of the greatest marches in the world history--to chart the two thousand uncharted miles from the Mississippi to the Missouri to the mysterious Stoney Mountains, then down Colombia to the Pacific.<br/><br/>But President Thomas Jefferson has other plans for the young Meriwether Lewis.  It is 1800, and Jefferson calls upon Lewis to be his secretary, ignoring Lewis' request for expedition.  The job, though a necessary duty, frustrates Lewis, whose mind is transfixed on his destiny to cross the continent.<br/><br/>Freed at last, Lewis calls upon his friend, William Clark to set out on a cross continental trek that will give them towering stature among explorers and assure that the young nation will have its shores washed by opposite oceans.<br/><br/>It is a dangerous expedition, as the unexplored territories are filled with huge grizzlies and wild waters, hostile Indians and they will lose their way.  They will also be blessed by Sacagawa, the Indian woman whose skill and insight will guide them and in many cases save them.  Until they reach the Oregon Country, where the breakers roll unbroken from China.<br/><br/>But for all Lewis' fortitude and genius, the man who made the impossible possible has touched the heights of his life and now steps towards his darkling future.<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Nevin
      </h2>
      
      <p class="authorDescription body article"><B>David Nevin</B> has spent more than twenty years researching and writing <I>The American Story</I>, a series of novels dealing with the history of the United States from 1800-1860.  He is the author of the<I> New York Times</I> bestselling <I>Dream West</I>,<I> 1812</I>, <I>Eagle's Cry</I> and <I>Treason</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?163ba881